import PropTypes from 'prop-types';

export default PropTypes.shape({
  email: PropTypes.string,
  fname: PropTypes.string,
  lname: PropTypes.string,
  phone: PropTypes.string,
  uuid: PropTypes.string,
});
